import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { canViewLabourWages } from '../../../shared/utils/workforceAccess';

/**
 * Who may open the wage screens at all.
 *
 * Operations (including Supervisor) and Management may record. Accounts may
 * LOOK — they reconcile these payments — so the guard tests viewing, and the
 * screens themselves hide the write actions. The server enforces the same split.
 */
const RequireLabourWageAccess = ({ children }) => {
  const allowed = canViewLabourWages(
    Cookies.get('userDesignation'),
    Cookies.get('userVertical')
  );
  if (!allowed) {
    return <Navigate to="/builder/operations/labour" replace />;
  }
  return children;
};

export default RequireLabourWageAccess;
